module.exports = __webpack_public_path__ + "img/company.7e9b9b31.svg";